import { Formik } from "formik";
import { Button, CardBody, Col, Form, FormGroup, Row } from "reactstrap";
import * as Yup from 'yup';
import SelectField from "../Utils/SelectField";
import InputField from "../Utils/InputField";
import { LabelText } from "../Utils/Input";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { addRatingGroup } from "../../slices/RatingGroup/AddRatingGroup/thunk";
import { editRatingGroup } from "../../slices/RatingGroup/UpdateRatingGroup/thunk";
import { Loader } from "../Utils/Loader";
import CommonButton from "../Utils/CommonButton";

export const RatingForm = ({ extractedData, toggleModals, setModalOpen, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const options1 = extractedData.map(({ eventType }) => ({
        label: eventType,
        value: eventType
    }));

    const uomMap = extractedData.reduce((acc, { eventType, uom }) => {
        acc[eventType] = { label: uom, value: uom };
        return acc;
    }, {});

    let initialValues = {
        serviceContextID: isEditMode ? initialData.serviceContextID : "",
        usageeventtype: isEditMode && initialData.eventType
            ?
            {
                label: initialData.eventType
                , value: initialData.eventType
            } : null,
        uom: isEditMode && initialData.uom ?
            { label: initialData.uom, value: initialData.uom } : null,
        serviceIdentifier: isEditMode ? initialData.serviceIdentifier : "",
        ratingGroup: isEditMode ? initialData.ratingGroup || '0' : "",
        avpName: isEditMode ? initialData.avpName : ""
    };

    const validationSchema = Yup.object().shape({
        usageeventtype: Yup.object().required("Enter the Event Type"),
        uom: Yup.object().required("Enter the UoM"),
        serviceContextID: Yup.string().required("Enter the Service Context ID"),
        serviceIdentifier: Yup.string(),
        ratingGroup: Yup.string()
    }).test('either-service-or-rating', 'Either Service Identifier or Rating Group is required', function (values) {
        const { serviceIdentifier, ratingGroup } = values;
        const hasServiceIdentifier = serviceIdentifier && serviceIdentifier.toString().trim() !== '';
        const hasRatingGroup = ratingGroup && ratingGroup.toString().trim() !== '';

        if (!hasServiceIdentifier && !hasRatingGroup) {
            const serviceError = this.createError({
                path: 'serviceIdentifier',
                message: 'Enter Service Identifier or Rating Group'
            });

            const ratingError = this.createError({
                path: 'ratingGroup',
                message: 'Enter Rating Group or Service Identifier'
            });

            return new Yup.ValidationError([serviceError, ratingError]);
        }
        return true;
    });

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={initialValues}
                onSubmit={async (values) => {
                    const payload = {
                        serviceContextID: values.serviceContextID || "",
                        eventType: values.usageeventtype?.value || "",
                        uom: values.uom?.value || "",
                        serviceIdentifier: values.serviceIdentifier || 0,
                        ratingGroup: parseInt(values.ratingGroup, 10) || 0,
                        avpName: values?.avpName || "",
                    };
                    if (!isEditMode) {
                        dispatch(addRatingGroup(payload, setLoading, setModalOpen))
                    } else {
                        dispatch(editRatingGroup(payload, initialData.ratingGroup, initialData.serviceIdentifier, initialData.serviceContextID, setLoading, setModalOpen))
                    }
                }}
            >
                {({
                    handleChange,
                    handleSubmit,
                    handleBlur,
                    errors,
                    touched,
                    values,
                    setFieldValue,
                }) => (
                    <Form className="needs-validation" onSubmit={handleSubmit}>
                        <Col lg={12}>
                            {loading && <Loader />}
                            <Row className="gy-4 px-3">
                                <CardBody>
                                    <Row>
                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"serviceContextID"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Service Context ID"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"serviceContextID"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.serviceContextID && errors.serviceContextID
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.serviceContextID && errors.serviceContextID
                                                                ? errors.serviceContextID
                                                                : "Enter Service Context ID"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"serviceContextID"}
                                                        type={"text"}
                                                        className={"form-control"}
                                                        id={"serviceContextID"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.serviceContextID || ''}
                                                        disabled={isEditMode}
                                                        invalid={touched.serviceContextID && errors.serviceContextID ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"serviceIdentifier"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Service Identifier"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"serviceIdentifier"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.serviceIdentifier && errors.serviceIdentifier
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.serviceIdentifier && errors.serviceIdentifier
                                                                ? errors.serviceIdentifier
                                                                : "Enter Service Identifier"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"serviceIdentifier"}
                                                        type={"number"}
                                                        className={"form-control"}
                                                        id={"serviceIdentifier"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.serviceIdentifier}
                                                        disabled={isEditMode}
                                                        invalid={touched.serviceIdentifier && errors.serviceIdentifier ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"ratingGroup"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Rating Group"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"ratingGroup"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.ratingGroup && errors.ratingGroup
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.ratingGroup && errors.ratingGroup
                                                                ? errors.ratingGroup
                                                                : "Enter Rating Group"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"ratingGroup"}
                                                        type={"number"}
                                                        className={"form-control"}
                                                        id={"ratingGroup"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.ratingGroup}
                                                        disabled={isEditMode}
                                                        invalid={touched.ratingGroup && errors.ratingGroup ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"usageeventtype"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Event Type"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"usageeventtype"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.usageeventtype && errors.usageeventtype
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.usageeventtype && errors.usageeventtype
                                                                ? errors.usageeventtype
                                                                : "Select an Event Type"
                                                        }
                                                    />
                                                    <SelectField
                                                        placeholder=""
                                                        options={options1}
                                                        value={values.usageeventtype || null}
                                                        className={`${touched.usageeventtype && !values.usageeventtype ? "error-input" : ""}`}
                                                        handleChange={(e) => {
                                                            setFieldValue("usageeventtype", e);
                                                            setFieldValue("uom", uomMap[e?.value] || null);
                                                        }}
                                                        isRVStyle={true}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"uom"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"UOM"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"uom"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.uom && errors.uom
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.uom && errors.uom
                                                                ? errors.uom
                                                                : "Select Unit of Measurement"
                                                        }
                                                    />
                                                    <SelectField
                                                        placeholder=""
                                                        options={[]}
                                                        className={`${touched.uom && !values.uom ? "error-input" : ""}`}
                                                        value={values.uom || null}
                                                        isRVStyle={true}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"avpName"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"AVP Name"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"avpName"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.avpName && errors.avpName
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.avpName && errors.avpName
                                                                ? errors.avpName
                                                                : "Enter AVP Name"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"avpName"}
                                                        type={"text"}
                                                        className={"form-control"}
                                                        id={"avpName"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.avpName || ''}
                                                        disabled={isEditMode}
                                                        invalid={touched.avpName && errors.avpName ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Row>
                        </Col>

                        {/* Submit and Cancel Buttons */}
                        <Row className="justify-content-end mb-2 mt-2">
                            <div className="live-preview">
                                <div className="d-flex justify-content-center gap-2 mt-2">
                                <CommonButton
                                        outline={true}
                                        className={
                                            "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                                        }
                                        color={"main-color"}
                                        type={"button"}  
                                        buttonAction={toggleModals}  
                                        buttonText={"Close"}
                                        icon={
                                            <i className="ri-close-fill label-icon align-middle fs-16 me-1" style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}>
                                            </i>
                                        }
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                    />
                                    <CommonButton
                                        color={"secondary"}
                                        type="submit"
                                        buttonText={"Submit"}
                                        icon={<i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>}
                                        className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                    />
                                </div>
                                {/* <div className="d-flex justify-content-center gap-2">
                                    <Button outline type="reset" onClick={toggleModals}>Close</Button>
                                    <Button type="submit" >Submit</Button>
                                </div> */}
                            </div>
                        </Row>
                    </Form>
                )}
            </Formik>
        </div>
    );
};